module.exports = [
  ...require('./_magicItemRawList_DMG_e'),
  require('./eversmoking_bottle'),
  require('./eye_of_vecna'),
]
